import moment from "moment";
import useModel from "../../../hooks/use-model.hook";
import I18 from "../../atoms/i18";
import { Avatar, AvatarCommunityPost } from "../../avatar.component";
import PostMenuActions from "./post-menu-actions.component";

/**
 * post options and user info
 * @param {*} param0
 * @returns
 */
export default function PostHeader({
  post,
  updatePost,
  deletePost,
  user,
  group,
  setEmbedModalVisible,
  setIsProcessing,
  addToast,
  isCommunityPost,
}) {
  const sample = moment
    .duration(moment(new Date()).diff(moment(post.createdAt)))
    .asDays();
  const isSharedPost = post.sharedId !== undefined && post.sharedId != null;
  const { createdAt, createdBy, groupRole } = isSharedPost ? post.shared : post;

  const { hideCreator, hideDate } = post.preferences ?? {};
  const {
    profileModelState: { setShowProfileModel, setIdToViewProfile },
  } = useModel();

  return (
    <div className="PostHeader flex items-center justify-between">
      {isCommunityPost && !hideCreator ? (
        <AvatarCommunityPost
          user={createdBy}
          post={post}
          size={42}
          className="cursor-pointer"
          tag={
            groupRole === "admin" ? (
              <div className="text-xxs mx-2 rounded bg-primary-foreground px-1 font-semibold text-primary">
                <I18>Admin</I18>
              </div>
            ) : groupRole === "moderator" ? (
              <div className="text-xxs mx-2 rounded bg-green-50 px-1 font-semibold text-green-500">
                <I18>Moderator</I18>
              </div>
            ) : groupRole === "user" ? (
              <></>
            ) : (
              <></>
            )
          }
          onClick={(e) => {
            // open the user page
            // history.push(createUserWallPageRoute(createdBy.id, "activity"));
            setIdToViewProfile(createdBy.id);
            setShowProfileModel(true);
          }}
        />
      ) : (
        /// Hide post author profile picture
        !hideCreator && (
          <>
            <Avatar
              user={createdBy}
              extraInfo={
                <span>
                  {!hideDate
                    ? sample < 1
                      ? moment(createdAt).fromNow()
                      : moment(createdAt).format("DD MMM YYYY")
                    : ""}
                </span>
              }
              size={42}
              className="cursor-pointer"
              tag={
                <span className="flex items-center gap-2">
                  {groupRole === "admin" ? (
                    <div className="text-xxs mx-2 rounded bg-primary-foreground px-1 font-semibold text-primary">
                      <I18>Admin</I18>
                    </div>
                  ) : groupRole === "moderator" ? (
                    <div className="text-xxs mx-2 rounded bg-green-50 px-1 font-semibold text-green-500">
                      <I18>Moderator</I18>
                    </div>
                  ) : groupRole === "user" ? (
                    <></>
                  ) : (
                    <div></div>
                  )}
                </span>
              }
              showSubtitle={createdBy?.shortBio}
              onClick={(e) => {
                // open the user page
                // history.push(createUserWallPageRoute(createdBy.id, "activity"));
                setIdToViewProfile(createdBy.id);
                setShowProfileModel(true);
              }}
            />
          </>
        )
      )}
      {/* Hide Post actions of post Author profile picture is hidden */}
      {!hideCreator && (
        <PostMenuActions
          addToast={addToast}
          deletePost={deletePost}
          group={group}
          post={post}
          setEmbedModalVisible={setEmbedModalVisible}
          setIsProcessing={setIsProcessing}
          updatePost={updatePost}
          user={user}
        />
      )}
    </div>
  );
}
